<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout justify-center wrap>
            <v-flex md12>
                <material-card
                    color="purple"
                    title="تقرير نتائج التحليل"
                    text="من خلال هذا التقرير يمكنك اظهار نتائج التحليل حسب المرض"
                >
                    <v-row v-if="showLoginError">
                        <v-col>
                            <v-alert color="red" type="error"> الحقل مطلوب </v-alert>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-row class="px-4 pt-4">
                            <v-col md="2" sm="12" xs="12" cols="12" class="my-0 py-0">
                                <v-autocomplete
                                    ref="healthdep"
                                    prepend-icon="mdi-account"
                                    v-model="healthdep"
                                    item-text="text"
                                    label="دائرة الصحة"
                                    :items="healthdeps"
                                />
                            </v-col>

                            <v-col md="2" sm="12" xs="12" cols="12" class="my-0 py-0">
                                <v-text-field
                                    ref="healthsector"
                                    prepend-icon="mdi-account"
                                    v-model="healthsector"
                                    label="القطاع"
                                />
                            </v-col>

                            <v-col md="2" sm="12" xs="12" cols="12" class="my-0 py-0">
                                <v-text-field
                                    ref="healthcenter"
                                    prepend-icon="mdi-account"
                                    v-model="healthcenter"
                                    label="المركز الصحي"
                                />
                            </v-col>

                            <v-col md="2" sm="12" xs="12" cols="12" class="my-0 py-0">
                                <v-autocomplete
                                    ref="sex"
                                    prepend-icon="mdi-account"
                                    v-model="sex"
                                    label="الجنس"
                                    :items="this.$store.state.sexitems"
                                />
                            </v-col>

                            <v-col md="2" sm="12" xs="12" cols="12" class="my-0 py-0">
                                <v-autocomplete
                                    ref="cardstatus"
                                    prepend-icon="mdi-account"
                                    v-model="cardstatus"
                                    label="حالة العينة"
                                    :items="this.$store.state.checktypes"
                                />
                            </v-col>

                            <v-col md="2" sm="12" xs="12" cols="12" class="my-0 py-0">
                                <v-autocomplete
                                    ref="disease"
                                    prepend-icon="mdi-account"
                                    @change="clear"
                                    v-model="disease"
                                    label="نوع المرض"
                                    :items="this.$store.state.disease"
                                    :rules="[rules.required]"
                                />
                            </v-col>

                            <v-col md="3" sm="12" xs="12" cols="12" class="my-0 py-0">
                                <v-dialog ref="dialog" v-model="modal" persistent width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="dateRangeText"
                                            label="التاريخ"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="dates2" scrollable range>
                                        <v-spacer></v-spacer>
                                        <v-btn text color="primary" @click="modal = false"
                                            >الغاء</v-btn
                                        >
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="
                                                $refs.dialog.save(date);
                                                getList();
                                            "
                                        >
                                            موافق
                                        </v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </v-col>

                            <v-col md="3" sm="12" xs="12" cols="12">
                                <v-btn @click="validate" dark color="indigo">
                                    <v-icon class="mr-1">mdi-chart-box-outline</v-icon> عرض التقرير
                                </v-btn>
                            </v-col>
                            <v-col md="3" sm="12" xs="12" cols="12">
                                <v-btn @click="validateDownload" dark color="green">
                                    <v-icon class="mr-1">mdi-file-excel</v-icon> تحميل
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-row>

                    <div>
                        <v-row class="mb-4" v-if="disease === 1">
                            <v-col cols="12">
                                <div><strong>نتائج تقرير الفحوصات لتحليل CHT</strong></div>
                                <v-simple-table dense>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th>رقم العينة</th>
                                                <th>اسم المراجع</th>
                                                <th>Screening Test (TSH)</th>
                                                <th>Confirmation (TSH)</th>
                                                <th>Confirmation (FTY)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in items" :key="item.index">
                                                <td>{{ item.barcode }}</td>
                                                <td>{{ item.fullname }}</td>
                                                <td>{{ item.sttsh }}</td>
                                                <td>{{ item.cttsh }}</td>
                                                <td>{{ item.ctfty }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-col>
                        </v-row>

                        <v-row class="mb-4" v-if="disease === 2">
                            <v-col cols="12">
                                <div><strong>نتائج تقرير الفحوصات لتحليل PKU</strong></div>
                                <v-simple-table dense>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th>رقم العينة</th>
                                                <th>اسم المراجع</th>
                                                <th>Screening Test (Phenylalanine)</th>
                                                <th>Confirmation (Phenylalanine)</th>
                                                <th>Confirmation (Tyrosine)</th>
                                                <th>Confirmation (PiT Ratio)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in items" :key="item.index">
                                                <td>{{ item.barcode }}</td>
                                                <td>{{ item.fullname }}</td>
                                                <td>{{ item.stph }}</td>
                                                <td>{{ item.ctph }}</td>
                                                <td>{{ item.ctpy }}</td>
                                                <td>{{ item.ctpr }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-col>
                        </v-row>

                        <v-row class="mb-4" v-if="disease === 3">
                            <v-col cols="12">
                                <div><strong>نتائج تقرير الفحوصات لتحليل Galactosemia</strong></div>
                                <v-simple-table dense>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th>رقم العينة</th>
                                                <th>اسم المراجع</th>
                                                <th>Screening Test (t. Glactose)</th>
                                                <th>Confirmation (t. Glactose)</th>
                                                <th>Confirmation (GALT)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in items" :key="item.index">
                                                <td>{{ item.barcode }}</td>
                                                <td>{{ item.fullname }}</td>
                                                <td>{{ item.sttg }}</td>
                                                <td>{{ item.cttg }}</td>
                                                <td>{{ item.ctgalt }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                    </div>
                </material-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { __HTTP, FormHeader } from "@/utils/utils";

export default {
    name: "ResultsReport",
    computed: {
        dateRangeText() {
            if (Date.parse(this.dates[0]) > Date.parse(this.dates[1])) {
                return "";
            } else return this.dates.join(" ~ ");
        },
        dates2: {
            get() {
                return this.dates;
            },
            set(date) {
                if (Date.parse(date[0]) > Date.parse(date[1]) && date.length > 1) {
                    this.dates = [];
                } else {
                    this.dates = date;
                }
            },
        },
    },
    mounted() {
        this.getHealthDeps();
    },
    methods: {
        clear() {
            this.items = [];
        },
        getList() {
            this.isloading = true;
            this.items = [];

            __HTTP(
                "?do=report&type=resultreport",
                JSON.stringify({
                    daterange: this.dateRangeText,
                    healthdep: this.healthdep,
                    healthcenter: this.healthcenter,
                    healthsector: this.healthsector,
                    sex: this.sex,
                    disease: this.disease,
                    cardstatus: this.cardstatus,
                    download: this.download,
                }),
                FormHeader,
                res => {
                    this.showLoginError = false;
                    this.isloading = false;
                    this.items = res;
                }
            );
        },
        downloadFunc() {
            this.isloading = true;

            __HTTP(
                "?do=report&type=resultreport",
                JSON.stringify({
                    daterange: this.dateRangeText,
                    healthdep: this.healthdep,
                    healthcenter: this.healthcenter,
                    healthsector: this.healthsector,
                    sex: this.sex,
                    disease: this.disease,
                    cardstatus: this.cardstatus,
                    download: true,
                }),
                FormHeader,
                res => {
                    this.showLoginError = false;
                    this.isloading = false;
                    const filePath = res.filePath;
                    console.log(filePath.slice(1));
                    const link = document.createElement("a");
                    link.href = "https://cphl.esite-lab.com" + filePath.slice(1);
                    link.download = "resultreport.xlsx";
                    link.target = "_blank";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            );
        },
        getHealthDeps() {
            __HTTP("?do=gethealthdeps", {}, FormHeader, res => {
                res.map(i => {
                    this.healthdeps.push({
                        text: i.title,
                        value: i.id,
                    });
                });
            });
        },
        submit() {
            this.getList();
            this.showTable = true;
        },
        validate() {
            if (this.disease) {
                this.submit();
                this.showLoginError = false;
            } else {
                this.showLoginError = true;
            }
        },
        validateDownload() {
            if (this.disease) {
                this.downloadFunc();
                this.showLoginError = false;
            } else {
                this.showLoginError = true;
            }
        },
    },
    data: () => ({
        download: false,
        showLoginError: false,
        rules: {
            required: value => !!value || "هذا الحقل مطلوب",
        },
        itemsOnCardType2: [],
        itemsOnCardType3: [],
        search: "",
        clientid: null,
        healthdep: "",
        healthsector: "",
        healthcenter: "",
        cardstatus: "",
        sex: "",
        isloading: false,
        showTable: false,
        modal: false,
        count: 0,
        dates: [],
        date: null,
        disease: "",
        healthdeps: [],
        itemsOnCardType: [],
        itemsOnSex: [],
        itemsOnHealthSector: [],
        itemsOnHealthCenter: [],
        itemsOnHealthDep: [],
        loadingtext: "يرجى الإنتظار جار تحميل البيانات ...",
        clients: [],
        items: [],
        user: [],
        snackbar: false,
    }),
};
</script>
